import { ErrorResponse } from '../../../../../types/API';
import { wgApi } from '../../../../app/src/features/api/wgApi';

export interface MaatwerkOfferteRequestAPI {
  sessionId: string;
  payload: unknown; // Use unknown to keep generic – validated by backend
}

export interface MaatwerkOfferteJobResponse {
  job_id: string;
}

/**
 * Sends the provided payload to AnvaFlows to export custom (maatwerk) quotes.
 * Returns the job id that can be polled via `/v1/api/flows/jobs/{jobId}`.
 */
export const requestMaatwerkOfferte = async (
  params: MaatwerkOfferteRequestAPI,
): Promise<MaatwerkOfferteJobResponse> => {
  const { sessionId, payload } = params;

  const { data, isError } = await wgApi.post<MaatwerkOfferteJobResponse>(
    `/v1/api/anvaflows/${sessionId}/send-custom-quotes-to-anva`,
    payload,
  );

  if (isError) throw new Error(JSON.stringify(data as ErrorResponse));

  return data;
};
